export const displayItemsCount = {
  tabletAndBelow: 6,
  desktop: 40
}
export const MENU_PAGES = {
  PARENT_CAT: 'parent_category',
  CHILD_CAT: 'child_category'
}
export const SORT_ORDER = {
  SORT_BY_DELIVERY_DATE: 'delivery_date_asc',
  SORT_BY_PRICE: 'unit_price_asc'
}
export const SORT_LABEL = {
  DELIVERY_DATE: '納期から選ぶ',
  QUICK_DELIVERY: '短納期順',
  BUDGET: '予算から選ぶ',
  LOW_UNIT_PRICE: '単価が安い順'
}
export const CATEGORY_SKUS_ENDPOINTS = '/skus?category_id='
